// * Device-id client service (server-minted). The backend returns a `deviceId` in the
//   login/quickLogin response; we persist it and attach it as `x-device-id` on auth
//   refresh/profile calls so the server can bind the session to the device.
//   We NEVER generate a client-side UUID — before the first login there is simply no header.

export const DEVICE_ID_STORAGE_KEY = "bfk-device-id";

export const getDeviceId = (): string | null => localStorage.getItem(DEVICE_ID_STORAGE_KEY);

// * Persist the server-minted device id. No-op when the response carries none.
export const storeDeviceId = (deviceId: string | null | undefined): void => {
  if (!deviceId) {
    return;
  }
  localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
};

// * Attach `x-device-id` when one has been persisted; absent from storage → send nothing
//   (the server handles a missing header).
type HeaderCarrier = { headers?: Partial<Record<string, unknown>> };

export const ensureHeader = (config: HeaderCarrier): void => {
  const deviceId = getDeviceId();
  if (!deviceId) {
    return;
  }
  config.headers = config.headers ?? {};
  config.headers["x-device-id"] = deviceId;
};
